import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { GetLoginChoiceResult } from '../../common/api/authService';

export interface SignupState {
  loginData?: GetLoginChoiceResult;
  account: {
    display?: string;
    email?: string;
    username?: string;
    policyids: string[];
  };
  profile?: {
    userdata: {
      organization: string;
      department: string;
      avatarOption: 'gravatar';
      gravatarDefault: 'identicon';
    };
    surveydata: {
      referralSources: {
        question: string;
        response: Record<string, string | boolean>;
      };
    };
  };
}

const initialState: SignupState = {
  loginData: undefined,
  account: {
    display: 'someName',
    email: 'someEmail@email.co',
    username: 'someUser',
    policyids: [],
  },
  profile: undefined,
};

export const signupSlice = createSlice({
  name: 'signup',
  initialState,
  reducers: {
    setLoginData: (state, action: PayloadAction<SignupState['loginData']>) => {
      // Set provider creeation data
      state.loginData = action.payload;
      // Set account defaults from provider
      const detail = action.payload?.create[0];
      state.account.display = detail?.provfullname;
      state.account.email = detail?.provemail;
      // ORCID's provusername is the numeric ORCID iD, which auth2 cannot
      // sanitize into a valid username and falls back to user<N>. Leave the
      // field blank for ORCID so the user picks their own.
      state.account.username =
        action.payload?.provider === 'OrcID'
          ? undefined
          : detail?.availablename;
    },
    setAccount: (
      state,
      action: PayloadAction<Partial<SignupState['account']>>
    ) => {
      state.account = { ...state.account, ...action.payload };
    },
    setProfile: (state, action: PayloadAction<SignupState['profile']>) => {
      state.profile = action.payload;
    },
    resetSignup: (state) => {
      state.account = initialState.account;
      state.loginData = initialState.loginData;
      state.profile = initialState.profile;
    },
  },
});

export default signupSlice.reducer;
export const { setLoginData, setAccount, setProfile, resetSignup } =
  signupSlice.actions;
